export default __webpack_public_path__ + "static/media/hht1_ep14_timeline_q04_a.7752e831.png";